export default {
  CopyVoucher: 'Sao chép chứng từ',
  ChooseTime: 'Chọn khoảng thời gian',
  GetData: 'Lấy dữ liệu',
  Cancel: 'Hủy',
  VoucherType: 'Loại chứng từ',
  Total: 'Tổng',
  TotalSelected: 'Số tiền được chọn/Tổng số tiền:',
  UpdateAccount: 'Cập nhật tài khoản sau sao chép',
  DebitAccount: 'TK Nợ',
  CreditAccount: 'TK Có',
  Agree: 'Đồng ý',
  DuToan: {
    LapDuToanThu: 'Lập dự toán thu',
    LapDuToanChi: 'Lập dự toán chi',
    DuToanDauNam: 'Nhận dự toán đầu năm',
    DuToanBoSung: 'Nhận dự toán bổ sung',
    DieuChinhDuToan: 'Điều chỉnh dự toán',
    PhieuRutTienKhoBac: 'Phiếu rút tiền kho bạc',
    ChuyenKhoanKhoBac: 'Chuyển khoản kho bạc',
    ChuyenKhoanKhoBacTienGui: 'Chuyển khoản kho bạc vào tài khoản tiền gửi',
    GhiThuGhiChi: 'Lập bảng kê ghi thu - ghi chi',
    ThanhToanTamUng: 'Lập bảng kê thanh toán tạm ứng',
    ChungTuThucChi: 'Lập bảng kê chứng từ thực chi',
    DieuChinhKinhPhi: 'Điều chỉnh kinh phí',
    DeNghiCamKetChi: 'Đề nghị cam kết chi',
    DuToanDuLai: 'Dự toán giữ lại',
    HuyDuToan: 'Hủy dự toán',
    VonDauTuXDBC: 'Kế hoạch vốn đầu tư XDCB',
    ThuChiHoatDongKhac: 'Kế hoạch thu chi hoạt động tài chính khác',
  },
  TienMat: {
    PhiThu: 'Phiếu thu',
    PhiChi: 'Phiếu chi',
    DieuChinhThu: 'Điều chỉnh kinh phí thu',
    DieuChinhChi: 'Điều chỉnh kinh phí chi',
  },
  TienGui: {
    NopTienKhoBac: 'Phiếu nộp tiền kho bạc',
    ChiTienGui: 'Chi tiền gửi',
    ChuyenTienNoiBo: 'Chuyển tiền nội bộ',
  },
  VatTu: {
    TienMat: 'Nhập mua bằng tiền mặt',
    TienGui: 'Nhập mua bằng tiền gửi',
    Khac: 'Nhập khác',
    PhieuXuatKho: 'Phiếu xuất kho',
    GhiTang: 'Phiếu ghi tăng CCDC',
    GhiGiam: 'Phiếu ghi giảm CCDC',
    ChuyenKho: 'Chuyển kho',
    DieuChuyen: 'Điều chuyển CCDC',
  },
  TaiSan: {
    GhiTang: 'Phiếu ghi tăng TSCĐ',
    GhiGiam: 'Phiếu ghi giảm TSCĐ',
    DieuChinh: 'Phiếu điều chỉnh TSCĐ',
    HaoMon: 'Hao mòn TSCĐ',
    DieuChuyen: 'Điều chuyển phòng ban',
  },
  Luong: {
    ChiTraLuong: 'Phiếu chi trả lương',
    ChiTienGui: 'Chi tiền gửi trả lương',
    HachToanChiPhiLuong: 'Hạch toán chi phí lương, BH, KPCĐ',
  },
  TongHop: {
    NghiepVuKhac: 'Chứng từ nghiệp vụ khác',
    KetChuyenHoatDongSuNghiep: 'Kết chuyển hoạt động sự nghiệp',
    KetChuyenCuoiNam: 'Kết chuyển cuối năm',
    KetChuyenLechThuChi: 'Kết chuyển chênh lệch thu, chi ngân sách xã',
    KetChuyenLechThuChiChinhLy: 'Kết chuyển chênh lệch thu, chi ngân sách xã trong thời gian chỉnh lý',
    KetChuyenDuNganSachChinhLy: 'Kết chuyển kết dư ngân sách xã trong thời gian chỉnh lý',
    KetChuyenDuNganSachXa: 'Kết chuyển kết dư ngân sách xã',
    KetChuyenChiNganSachThoiGianChinhLy: 'Kết chuyển chi ngân sách trong thời gian chỉnh lý',
    KetChuyenTaiKhoan: 'Phiếu kết chuyển tài khoản',
    QuyetToan: 'Quyết toán dự toán chi ngân sách cuối năm',
    KetChuyenDuSangThuNganSachXa: 'Kết chuyển kết dư sang thu ngân sách xã',
    ChungTuGhiSo: 'Chứng từ ghi sổ đồng thời',
  },
};
